import type { ReactNode, UIEvent } from 'react';
import React, { forwardRef } from 'react';

import { Wrapper } from './Content.styled';

export interface ContentProps {
  children: ReactNode;
  /**
   * Allows you to block the scroll
   */
  scrollBlocked?: boolean;
  /**
   * Function that is executed when the user scrolls
   */
  onScroll?: (e: UIEvent<HTMLDivElement>) => void;
}

const Content = forwardRef<HTMLDivElement, ContentProps>(
  ({ children, scrollBlocked = false, onScroll }, ref) => {
    return (
      <Wrapper ref={ref} $scrollBlocked={scrollBlocked} onScroll={onScroll}>
        {children}
      </Wrapper>
    );
  },
);

export default Content;
